/**
 * Importação da biblioteca axios para fazer requisições baseadas em Promises.
 */
import axios from 'axios';

export const get = async (
  server,
  typeName,
  count = null,
  startIndex = null,
  wfsVersion = '2.0.0'
) => {
  const params = {
    service: 'WFS',
    version: wfsVersion,
    request: 'GetFeature',
    typeName,
    outputFormat: 'application/json',
  };
  if (count) params.count = count;
  if (startIndex) params.startIndex = startIndex;
  return axios(`${server}`, { params });
};
